import { Component } from '@angular/core';
import { MarcacaoModel } from "../../models/marcacao.model";
import { SharedMarcacaoService } from "../../services/shared-marcacao.service";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PrintService } from "../../services/print.service";
import { ToastrService } from "ngx-toastr";
import { MedicoService } from "../../services/medico.service";
import { MedicoModel } from 'src/app/models/medico.model';

@Component({
  selector: 'app-encaminhamento',
  templateUrl: './encaminhamento.component.html',
  styleUrls: ['./encaminhamento.component.scss']
})
export class EncaminhamentoComponent {
  protected marcacaoAtual: MarcacaoModel;
  protected solicitacaoCopiada: string = '';
  protected solicitacao_SafeHtml: SafeHtml | null = null;
  protected medicos: MedicoModel[] = [];

  constructor(private sharedMarcacaoService: SharedMarcacaoService,
    private printService: PrintService,
    private sanitizer: DomSanitizer,
    private toastrService: ToastrService,
    private medicoService: MedicoService,
  ) {
    this.marcacaoAtual = new MarcacaoModel();
  }

  ngOnInit() {
    this.sharedMarcacaoService.marcacaoAtual.subscribe((res) => {
      this.marcacaoAtual = res ?? new MarcacaoModel();
      if (this.marcacaoAtual?.seq_Setor) {
        this.carregarMedicos(this.marcacaoAtual.seq_Setor, 'A');
      }
    });

    this.sharedMarcacaoService.solicitacaoCopiada.subscribe((solicitacao) => {
      this.solicitacaoCopiada = solicitacao;
    });
  }

  imprimir() {
    const medico = this.marcacaoAtual.corpoClinico?.profissional;
    
    const medicoNome = medico?.nome;
    const numConselho = medico?.num_Conselho;
    const listaHtml = this.geraHtmlMedicos(this.medicos);

    const medicos = `
    ${listaHtml}
      <div style="padding-left: 240px; font-size: 12px; line-height: 1.4;">
      ${this.marcacaoAtual.solicitacoes ?? ''}
    </div>
  `;
    this.printService.printHtmlString('Encaminhamento', this.marcacaoAtual.beneficiario?.nome_Beneficiario, medicos, medico, numConselho);
  }

  public copiarSolicitacao() {
    const FINALIZADO = 7;
    const REALIZADO = 6;

    if ((this.marcacaoAtual.status_Atendimento === FINALIZADO || this.marcacaoAtual.status_Atendimento === REALIZADO)
      && this.marcacaoAtual.solicitacoes) {

      this.sharedMarcacaoService.setSolicitacaoCopiada(this.marcacaoAtual.solicitacoes);
      this.toastrService.success('Encaminhamento copiado com sucesso!', 'Copiado');
    }
    else {
      this.toastrService.warning('Este botão só pode ser usado em atendimentos FINALIZADOS que contenham Encaminhamentos.', 'Atenção');
    }
  }

  public colarSolicitacao() {
    const EM_ATENDIMENTO = 5;

    if (this.solicitacaoCopiada && this.marcacaoAtual.status_Atendimento === EM_ATENDIMENTO) {

      this.marcacaoAtual.solicitacoes =
        (this.marcacaoAtual.solicitacoes || '') + this.solicitacaoCopiada;

      this.solicitacao_SafeHtml =
        this.sanitizer.bypassSecurityTrustHtml(this.marcacaoAtual.solicitacoes);

      this.toastrService.success('Encaminhamento anterior colado com sucesso!', 'Sucesso');

      this.sharedMarcacaoService.setSolicitacaoCopiada('');

    } else {
      this.toastrService.warning('O botão Colar só está habilitado para o atendimento com status igual à EM ATENDIMENTO.', 'Atenção');
    }
  }

  public format(command: string) {
    document.execCommand(command, false, '');
  }

  public setColor(event: any) {
    const color = event.target.value;
    document.execCommand('foreColor', false, color);
  }

  public setBackground(event: any) {
    const color = event.target.value;
    document.execCommand('hiliteColor', false, color);
  }

  carregarMedicos(seqSetor: number, status: string) {
    this.medicoService.getMedicos(seqSetor, status).subscribe({
      next: (res) => {
        if (!res.success) {
          return;
        }

        this.medicos = (res.data ?? []).flat();

      },
      error: (err) => {
        this.toastrService.error("Erro ao buscar médicos:", err);
      }
    });
  }

  geraHtmlMedicos(medicos: MedicoModel[]): string {
    if (!medicos || medicos.length === 0) return '';

    const itens = medicos.map(m => `
      <div style="margin-bottom: 6px;">
        <div style="font-weight: bold; font-size: 11px; color: #1a7f2e;">
          ${m.nome ?? ''}
        </div>
        <div style="font-weight: bold; font-size: 11px; color: #1a7f2e;">
          ${m.descricao_Especialidade ?? ''}
        </div>
      </div>
  `).join('');

    return `
    <div id="listaMedicos" style="
      position: fixed;
      top: 140px;
      left: 20px;
      width: 200px;
      height: auto;
    ">
      ${itens}
    </div>
  `;
  }

}
